function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { AxisType, PointType } from '../enum';
import { Region } from './Region';
export var RangeRegion = function (_Region) {
  _inherits(RangeRegion, _Region);

  var _super = _createSuper(RangeRegion);

  function RangeRegion(isSlider) {
    var _this;

    _classCallCheck(this, RangeRegion);

    _this = _super.call(this, isSlider);
    _this.isTrying = false;
    _this.changeOnEnd = false;
    _this.startValue = 0;
    _this.endValue = 0;
    _this.tryingStartValue = 0;
    _this.tryingEndValue = 0;

    _this.createPoint('start', PointType.RIGHT);

    _this.createPoint('end', PointType.RIGHT);

    return _this;
  }

  _createClass(RangeRegion, [{
    key: "updateOptions",
    value: function updateOptions(options) {
      var value = options.value,
          _options$changeOnEnd = options.changeOnEnd,
          changeOnEnd = _options$changeOnEnd === void 0 ? false : _options$changeOnEnd,
          config = _objectWithoutProperties(options, ["value", "changeOnEnd"]);

      var sd = this.getPoint('start').getDragging();
      var ed = this.getPoint('end').getDragging();
      var swap = ed && value[0] !== this.startValue && value[1] === this.startValue || sd && value[1] !== this.endValue && value[0] === this.endValue;
      this.changeOnEnd = changeOnEnd;
      this.startValue = value[swap ? 1 : 0] || 0;
      this.endValue = value[swap ? 0 : 1] || 0;

      if (!this.getDragging()) {
        this.tryingStartValue = 0;
        this.tryingEndValue = 0;
        this.isTrying = false;
      }

      this.getAxis(AxisType.HORIZONTAL).updateAxisConfig(config);
      this.getPoint('start').updatePointValue();
      this.getPoint('end').updatePointValue();
      this.repaint();
    }
  }, {
    key: "setPointValue",
    value: function setPointValue(part, value, virtual) {
      if (part !== 'end' && part !== 'start') {
        throw new Error('range region has two valid part start/end');
      }

      if (this.changeOnEnd && virtual) {
        this[part === 'start' ? 'tryingStartValue' : 'tryingEndValue'] = value.x;
        this.getPoint('start').repaint();
        this.getPoint('end').repaint();
        return;
      }

      var start = part === 'start' ? value.x : this.startValue;
      var end = part === 'end' ? value.x : this.endValue;
      this.emit('change', [Math.min(start, end), Math.max(start, end)]);
    }
  }, {
    key: "getPointValue",
    value: function getPointValue(part) {
      if (part !== 'end' && part !== 'start') {
        throw new Error('range region has two valid part start/end');
      }

      if (part === 'end') {
        return {
          x: this.isTrying ? this.tryingEndValue : this.endValue,
          y: 0
        };
      }

      return {
        x: this.isTrying ? this.tryingStartValue : this.startValue,
        y: 0
      };
    }
  }, {
    key: "isValueSelected",
    value: function isValueSelected(value) {
      return this.isAxisSelected(AxisType.HORIZONTAL, value.x);
    }
  }, {
    key: "isAxisSelected",
    value: function isAxisSelected(type, value) {
      if (type === AxisType.HORIZONTAL) {
        var _this$getSelectedRegi = this.getSelectedRegion(),
            _this$getSelectedRegi2 = _slicedToArray(_this$getSelectedRegi, 2),
            start = _this$getSelectedRegi2[0],
            end = _this$getSelectedRegi2[1];

        return value <= end.x && value >= start.x;
      }

      return false;
    }
  }, {
    key: "getPointByOffset",
    value: function getPointByOffset(offset) {
      var deltaS = Math.abs(this.getPoint('start').getOffset().x - offset.x);
      var deltaE = Math.abs(this.getPoint('end').getOffset().x - offset.x);
      return deltaE <= deltaS ? this.getPoint('end') : this.getPoint('start');
    }
  }, {
    key: "getSelectedRegion",
    value: function getSelectedRegion() {
      var start = this.isTrying ? this.tryingStartValue : this.startValue;
      var end = this.isTrying ? this.tryingEndValue : this.endValue;
      return [{
        x: Math.min(start, end),
        y: 0
      }, {
        x: Math.max(start, end),
        y: 0
      }];
    }
  }, {
    key: "getSelectedOffset",
    value: function getSelectedOffset() {
      var start = this.getPoint('start').getOffset().x;
      var end = this.getPoint('end').getOffset().x;
      return [{
        x: Math.min(start, end),
        y: 0
      }, {
        x: Math.max(start, end),
        y: 0
      }];
    }
  }]);

  return RangeRegion;
}(Region);